<template lang="pug">
header
    nav.navbar(:class="{usual: !isTop, show: isMenuShow}")
        .navbar-brand
            a.navbar-item.logo(href='/')
                svg.svg.is-desktop(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.91 48.33" v-show="!isTop" :class="{light: isLight}")
                    g#layer
                        g#mode
                            path.cls-1(d="M42.88,17l2.34,2.34-1.95,1.95a16.73,16.73,0,0,1-11.89,4.92H28.07a3.31,3.31,0,0,1,3.31-3.31h0A13.41,13.41,0,0,0,40.93,19ZM38,12.16l2.34,2.33-2,2a9.86,9.86,0,0,1-7,2.91H28.07A3.31,3.31,0,0,1,31.38,16h0a6.57,6.57,0,0,0,4.68-1.94ZM31.56,6.87A2.81,2.81,0,0,1,34.3,9.71v2.67H31.63a2.81,2.81,0,0,1-2.84-2.74A2.76,2.76,0,0,1,31.56,6.87ZM9.16,26.44,6.82,24.1l1.95-2a23.54,23.54,0,0,1,16.76-6.94h3.31a3.31,3.31,0,0,1-3.31,3.3h0a20.27,20.27,0,0,0-14.42,6ZM14,31.31,11.69,29l2-1.95A16.73,16.73,0,0,1,25.53,22.1h3.31a3.31,3.31,0,0,1-3.31,3.31h0A13.41,13.41,0,0,0,16,29.36Zm4.88,4.87-2.34-2.34,1.95-1.94a9.82,9.82,0,0,1,7-2.91h3.31a3.31,3.31,0,0,1-3.31,3.31h0a6.58,6.58,0,0,0-4.68,1.93Zm6.49,5.29a2.81,2.81,0,0,1-2.84-2.75A2.75,2.75,0,0,1,25.33,36a2.8,2.8,0,0,1,2.74,2.83v2.68ZM48.14,26.19a23.52,23.52,0,0,1-16.76,6.94H28.07a3.31,3.31,0,0,1,3.31-3.31h0a20.26,20.26,0,0,0,14.42-6l2-2,2.34,2.34Z")
                            path.cls-1(d="M28.46,48.33a10.31,10.31,0,0,1-7.32-3L0,24.17,21.14,3A10.36,10.36,0,0,1,35.78,3L56.91,24.17,35.78,45.31A10.31,10.31,0,0,1,28.46,48.33Zm-6.15-4.19a8.71,8.71,0,0,0,12.3,0l20-20-20-20a8.69,8.69,0,0,0-12.3,0l-20,20Z")
                            path.cls-1(d="M25.4,41.47a2.81,2.81,0,0,1-2.84-2.75A2.75,2.75,0,0,1,25.33,36a2.8,2.8,0,0,1,2.74,2.83v2.68Z")

                img.is-mobile(src='@/assets/img/icon/logo-wide.png' alt='Wi-Monitor' v-show="!isTop || isMenuShow")
            a.live.is-mobile(href='#live') LIVE
            .navbar-burger(@click="toggleMenu")
                span
                span
                span
        scrollactive.navbar-menu.is-desktop#menu(active-class="current" :offset="0" :duration="400" bezier-easing-value="0.55, 0.05, 0.22, 0.99" v-on:itemchanged="onItemChanged" :class="{light: isLight}" scrollContainerSelector=".main")
            a.scrollactive-item.navbar-item.dotstyle.current(href='#top') TOP
            a.scrollactive-item.navbar-item.dotstyle(href='#about') ABOUT
            a.scrollactive-item.navbar-item.dotstyle(href='#concept') CONCEPT
            a.scrollactive-item.navbar-item.dotstyle.live(href='#live') LIVE
            a.scrollactive-item.navbar-item.dotstyle.point(href='#point') ADVANTAGES
            a.scrollactive-item.navbar-item.dotstyle(href='#method') METHOD
            a.scrollactive-item.navbar-item.dotstyle(href='#member') MEMBER
            a.scrollactive-item.navbar-item.dotstyle(href='#gallery') GALLERY
            a.scrollactive-item.navbar-item.dotstyle(href='#contact') CONTACT
            span.line(ref="line")
            a.twitter(target="_blank" href="https://twitter.com/WiMonitor" rel="noopener noreferrer")
                i.fab.fa-twitter

        .navbar-menu.is-mobile#mobile-menu
            a.navbar-item(href='#top' @click="toggleMenu") Top
            a.navbar-item(href='#about' @click="toggleMenu") About
            a.navbar-item(href='#concept' @click="toggleMenu") Concept
            a.navbar-item(href='#live' @click="toggleMenu") Live
            a.navbar-item(href='#point' @click="toggleMenu") Advantages
            a.navbar-item(href='#method' @click="toggleMenu") Method
            a.navbar-item(href='#member' @click="toggleMenu") Member
            a.navbar-item(href='#gallery' @click="toggleMenu") Gallery
            a.navbar-item(href='#contact' @click="toggleMenu") Contact
            a.twitter(target="_blank" href="https://twitter.com/WiMonitor" rel="noopener noreferrer")
                i.fab.fa-twitter
    
</template>

<script>
import VueScrollactive from 'vue-scrollactive';

export default {
    name: 'App',
    data () {
        return {
            activeColor: '#ff0000',
            isMenuShow: false,
            isLight: true,
            isTop: true,
            clientHeight: 0,
            scrollHeight: 0,
            mainEl: null
        }
    },
    components: {
        VueScrollactive
    },
    mounted() {
        const element = document.querySelector('.main');
        this.mainEl = element
        this.clientHeight = element.clientHeight;
        this.scrollHeight = element.scrollHeight;
    },
    methods: {
        onItemChanged(event, currentItem) {
            if(currentItem){
                let line = this.$refs.line
                line.style.top = currentItem.offsetTop + 8 + 'px'
                const position = currentItem.href
                if(position.includes('#top')){
                    this.isLight = true
                    this.isTop = true
                } else if (this.scrollHeight - (this.clientHeight + this.mainEl.scrollTop) == 0){
                    this.isLight = false
                    this.isTop = false
                } else if (position.includes('#about') || position.includes('#point') || position.includes('#method') || position.includes('#member') || position.includes('#gallery')){
                    this.isLight = true
                    this.isTop = false
                } else {
                    this.isLight = false
                    this.isTop = false
                }
            }
        },
        toggleMenu() {
            this.isMenuShow = !this.isMenuShow
        }
    }
}

</script>

<style scoped lang="stylus">

.scrollactive-item.active
    background orange

@keyframes flash{
    0% {
        transform translateY(-50%) scale(1.0)
        opacity 1
    }
    100%{
        opacity 0
        transform translateY(-50%) scale(1.5)
    }
}

// header
nav.navbar
    top 0
    left 0
    position fixed
    background-color rgba(0, 0, 0, 0)
    width nav-width
    height 100%
    center-align()
    .live
        color black
        font-weight bold
        align-self center
        margin-left auto
        &::before
            content ''
            position absolute
            top 50%
            transform translateY(-50%)
            left 48px
            border-radius 50%
            width 12px
            height 12px
            background-color sub-color
            animation flash 2s ease-in-out infinite .3s
    .navbar-brand
        width 100%
        position absolute
        top 0
        .logo
            background-color rgba(0, 0, 0, 0)
            width 120px
            height auto 
            margin 36px auto
            img
                max-height initial
                width 100%
            .svg
                fill text-color
            .svg.light
                fill main-color
            &:focus, &:hover
                background-color rgba(0, 0, 0, 0)
                outline none
        .navbar-burger
            height nav-height
            color main-color
            -webkit-tap-highlight-color rgba(0,0,0,0)
            transition all .4s
            &:hover
                background-color rgba(0, 0, 0, 0)
            &:focus
                outline none
        &:hover
            .logo
                opacity .85
    .navbar-menu
        flex-direction column
        position absolute
        top 50%
        transform translateY(-50%)
        a.navbar-item
            font-weight 400
            font-size 14px
            color text-color
            padding 12px 0 12px 8px
            transition color .2s
            &.dotstyle
                opacity .8
                &.current
                    opacity 1
                    &::after
                        width 10px
                        height 10px
                        left -8px
                &::after
                    content ''
                    position absolute
                    top 52%
                    transform translateY(-50%)
                    border-radius 50%
                    left -7px
                    width 8px
                    height 8px
                    background-color rgba(0, 0, 0, 0)
                    border 1px solid text-color
                    transition all .2s ease-in
            &:hover
                background-color rgba(0, 0, 0, 0)
                color middle-color !important
            &:focus
                color text-color !important
                background-color rgba(0, 0, 0, 0)
                outline none
                
        .line
            width 29px
            height 29px
            display block
            position absolute
            left -18px
            top 8px
            transition top .6s
            transform rotate(45deg)
            background-color rgba(255, 255, 255, .2)
            border-radius 6px 0 6px 0
        a.twitter
            display inline-block
            margin 4px 8px 4px 24px
            color text-color
            font-size 1.2em
            &:hover
                color #1DA1F2
        &.show
            display block
        a.navbar-item.is-active, a.navbar-item:focus, a.navbar-item:focus-within, a.navbar-item:hover
            color main-color
        &.light
            a.navbar-item
                color main-color
                &.dotstyle
                    &::after
                        border 1px solid main-color
                &:focus
                    color main-color !important
            a.twitter
                color main-color
                &:hover
                    color #1DA1F2
            .line
                background-color rgba(29, 32, 136, .2)

.is-desktop
    display block
.is-mobile
    display none

+tb()
    .is-desktop
        display none
    .is-mobile
        display block
    nav.navbar
        width 100%
        top 0
        left 0
        padding 0
        background-color rgba(0, 0, 0, 0)
        height nav-height
        transition all .4s cubic-bezier(.22,.68,0,1.71)
        .live
            margin-left auto
            padding-right 16px
            color main-color
            &::before
                left initial
                right 3.25rem
                width 10px
                height 10px
                background-color sub-color
        .navbar-brand
            .logo
                margin 0 24px
                padding 0
            .navbar-burger
                margin-left 0
        .navbar-menu.is-mobile
            padding 0
            height 100vh
            width 100%
            position initial
            transform initial
            center-align()
            justify-content flex-start
            box-shadow none
            background-color main-color
            padding 16px
            position fixed
            top nav-height
            left 100%
            transition left .3s cubic-bezier(0.55, 0.05, 0.22, 0.99)
            overflow-y scroll
            a.navbar-item
                text-align center
                margin 8px 0
                padding 16px 0
                color main-color
                background-color text-color
                width 100%
                &:focus
                    color text-color !important
        &.usual
            background-color bg2-color
            border-bottom 1px solid main-color
        &.show
            background-color text-color
            .navbar-menu.is-mobile
                left 0
            .navbar-brand
                .navbar-burger
                    transform rotate(-90deg)
+sp()
    nav.navbar
        .navbar-menu.is-mobile
            a.navbar-item
                margin 4px 0
                padding 8px 0
                font-size 17px
        .navbar-brand
            .logo
                margin 0 16px
                

</style>